var AutoScheduleFormatResult = /** @class */ (function () {
    function AutoScheduleFormatResult() {
        this.topRecommendList = [];
        this.allRecommendList = [];
        this.pushOutRecommendList = [];
    }
    return AutoScheduleFormatResult;
}());
export { AutoScheduleFormatResult };
